import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from '../../util/base-service.service';
import { HttpConst } from '../../core/resources/http/http.const';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
@Injectable()
export class CreditoService extends BaseService {

  private $api = `${HttpConst.apiUrl}`;
  private $controllerName = 'Credito';
  private $ExternalApi = HttpConst.ExternalAPIS; //ADD EXP(GVASQUEZ) 20241001 - REQ37988: Nueva variable para las URLS Externas

  constructor(private http: HttpClient) { super(http); }

  obtenerClienteCreditos(idusuario: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/ListarClienteCreditos`, idusuario);
    return resultado;
  }
  obtenerClienteCreditosTerminados(idusuario: any){
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/ListarClienteCreditosTerminados`, idusuario);
    return resultado;
  }

  obtenerDatosPrincipalCredito(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/DatosPrincipalCredito`, input);
    return resultado;
  }
  obtenerDatosPrincipalCreditoTerminado(input: any){
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/DatosPrincipalCreditoTerminado`, input);
    return resultado;
  }

  ObtenerCuotaPagar(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/DatosCuotaPagar`, input);
    return resultado;
  }
  DescargarContrato(NumCredito: any) {
    const resultado = <Promise<any>>this.httpGetArchivo(`${this.$api}/${this.$controllerName}/DescargarContrato/${NumCredito}`);
    return resultado;
  }
  //INI EXP(WTAI) REQ21135 20211221
  DescargarArchivo(NumCredito: any,TipoDocumento: any) {
    // TipoDocumento =1  //contrato
    // TipoDocumento =2  //carta de no adeudo
    const resultado = <Promise<any>>this.httpGetArchivo(`${this.$api}/${this.$controllerName}/DescargarArchivo/${NumCredito}/${TipoDocumento}`);
    return resultado;
  }
  //FIN EXP(WTAI) REQ21135 20211221

  //INI INE(JJGJ) REQ21559 20220221
  //ADD EXP_AVR(2023-07-01) PARAMETRO SOLICITADO PARA EL LISTADO CREDITOS

  ValidarCartaNoAdeudo(NumOperacion: any) {
     const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/ValidarCartaNoAdeudo`, NumOperacion);
     return resultado;
    }

//ADD EXP_AVR(2023-07-01) PARAMETRO SOLICITADO PARA EL LISTADO CREDITOS
    DescargarCartaNoAdeudo(NumOperacion: any) {
      const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/DescargarCartaNoAdeudo`, NumOperacion);
       return resultado;
     }
    //FIN  INE(JJGJ) REQ21559 20220221
    //INI EXP(GVASQUEZ) 20241001 - REQ37988: Método convertido asíncrono
    async DescargarCartaNoAdeudoV2(NumCredito: any, NroDocumento: string): Promise<any>{
      const resultado = await this.httpGetArchivoExterno(`${this.$ExternalApi.api_bank}/DescargarCartaNoAdeudo_V2?numCredito=${NumCredito}&nroDocumento=${NroDocumento}`);
      return resultado;
    }
    //FIN EXP_GVASQUEZ(2024-09-17) REQ 37988 CARTA NO ADEUDO
//INI INE(PVR) 20240219 REQ25710
    EnviarCorreoCreditoVehicular(CreditoVehicularRequest: any) {
      const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/EnviarCorreoCreditoVehicular`, CreditoVehicularRequest);
       return resultado;
     }
     ObtenerCreditoPersonalPreApobado(ObtenerCreditoPersonal: any) {
       const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/ObtenerCreditoPersonal`, ObtenerCreditoPersonal);
       return resultado;
      }
      ObtenerSeguroVehicular(ObtenerCreditoPersonal: any) {
       const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/ObtenerSeguroVehicular`, ObtenerCreditoPersonal);
        return resultado;
      }
//FIN INE(PVR) 20240219 REQ25710
}
